export default __webpack_public_path__ + "static/media/partsinfo.cddcdd5c.mp4";